import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  message,
  Spin,
  Form,
  Avatar
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { useDispatch, useStore, useSelector } from 'react-redux'
import {
  loadAddCashModalShow,
  loadIsRegistorLoading,
  loadCashListingLoading
} from '../../../appRedux/actions/Sell'
import CashAdd from './CashAdd'
import OpeningFloat from './OpeningFloat'
import { CASH_LISTING } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import {
  loadIsSelectReg,
  setCommonConfigs
} from '../../../appRedux/actions/CommonData'
import {
  checkRightspermissions,
  formatDigits,
  isEmptyObject
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const CashListing = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )
  const getReduxCashListingDataLoading = useSelector(
    ({ Sell }) => Sell.cashListingDataLoading
  )
  const getReduxCashListingLoading = useSelector(
    ({ Sell }) => Sell.cashListingLoading
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [getTableData, setTableData] = React.useState([])
  const [getCashRole, setCashRole] = useState(0)
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [getPagination, setPagination] = React.useState({
    CashManagementID: '',
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getRegName, setRegName] = useState('')
  const [getOutletName, setOutletName] = useState('')

  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'sell.cashlisting.title')
    }

    dispatch(setCommonConfigs(CASH_LISTING))
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outlet = false
      let reg = false
      if (getReduxSelectedStoreOutlets.id) {
        // setSelectedOutlet(getReduxSelectedStoreOutlets.id);
        setOutletName(
          getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : ''
        )
        outlet = getReduxSelectedStoreOutlets.id
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          // setSelectedOutlet(
          //   getReduxSelectedStoreOutlets.id
          //     ? getReduxSelectedStoreOutlets.id
          //     : selectedLocalOut.id
          // );
          setOutletName(
            selectedLocalOut && selectedLocalOut.outlet
              ? selectedLocalOut.outlet
              : ''
          )
          outlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
        } else {
          setOutletName('')
        }
      }

      if (getReduxSelectedOutletReg.id) {
        setRegName(
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
            ? getReduxSelectedOutletReg.register
            : ''
        )
        reg =
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : ''
      } else {
        let selectedReg = localStorage.getItem('selectedReg')
        if (selectedReg) {
          selectedReg = JSON.parse(selectedReg)
          setRegName(
            getReduxSelectedOutletReg.register
              ? getReduxSelectedOutletReg.register
              : selectedReg.register
          )
          reg = getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : selectedReg.id
        } else {
          setRegName('')
        }
      }

      if (!outlet || !reg) {
        dispatch(loadIsSelectReg(true))
      }

      return () => (mounted = false)
      // //;
    }
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    // getUpcomingData(getCurrentPagination);
    let cashmanageId = localStorage.getItem('cashManageID')
    if (cashmanageId) {
      let body = getPagination
      body.CashManagementID = cashmanageId
      setPagination(body)
      getCashListingService(body)
    }
  }, [getReduxCashListingDataLoading])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  async function getCashListingService (body) {
    //
    const geCashListin = ds.getCashManagementService(body, BEHAVIOUR_TYPE.GET)
    await geCashListin
      .then(res => {
        dispatch(loadCashListingLoading(false))
        // dispatch(loadIsRegistorLoading(false));
        setIsLoadingTable(false)
        if (res && res.length > 0) {
          setIsLoading(false)
          let data = res.map((e, key) => {
            return {
              id: key,
              userid: e.id,
              date: e.createdOnDate,
              createdon: e.createdOn,
              email: e.userEmail,
              name: e.userName,
              note: e.note,
              reason: e.reason,
              nameLetter: e.lettersName,
              transaction: e.transaction,
              role: e.roleName
            }
          })
          let paginationobj = {
            CashManagementID: body.CashManagementID,
            CurrentPageNo: res[0].currentPageNo,
            PageSize: res[0].pageSize,
            total: res[0].totalRecords,
            showSizeChanger: true
          }
          data.sort((a, b) => (a.createdon < b.createdon ? 1 : -1))
          setTableData(data)
          setPagination(paginationobj)
        }
      })
      .catch(e => {
        setIsLoading(false)
        setIsLoadingTable(false)
        dispatch(loadCashListingLoading(false))
        // dispatch(loadIsRegistorLoading(false));
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }

  function evenOrOdd (num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return 'even'
    } else {
      return 'odd'
    }
  }

  const columns = [
    {
      title: <IntlMessages id='sell.cashlisting.col1' />,
      dataIndex: 'date',
      key: 'date',
      render: (text, record) => {
        let date = ''
        if (record.createdon) {
          if (record.createdon.includes('T')) {
            date = record.createdon.split('T')[1]
          }
        }
        return (
          <div>
            <h5 style={{ color: '#05314a' }}>{text}</h5>
            <p>{date}</p>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.cashlisting.col2' />,
      dataIndex: 'email',
      key: 'email',
      render: (text, record, key) => {
        let isEvenOrOdd = evenOrOdd(key)
        return (
          <>
            <div className='gx-module-list-icon'>
              <Row gutter={12}>
                <Col>
                  <div className='gx'>
                    <Avatar
                      style={{ fontWeight: 'bold' }}
                      className={`gx-avatar gx-bg-${
                        isEvenOrOdd == 'even' ? 'green' : 'blue'
                      } gx-size-46 mr-10`}
                    >
                      {record.nameLetter}
                    </Avatar>
                  </div>
                </Col>

                <Col>
                  <div className='gx-module-list-content'>
                    <div className='gx-mail-user-des'>
                      <span className='gx-sender-name'>{record.name}</span>

                      <span className='gx-toolbar-separator'>&nbsp;</span>

                      <span className='vd-flag sm:hidden'>{record.role}</span>
                    </div>
                    <div className='gx-message'>
                      <p className='gx-text-truncate'> {text}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='sell.cashlisting.col3' />,
      dataIndex: 'note',
      key: 'Reasons',
      render: (text, record) => {
        return (
          <div>
            <Row>
              <Col>
                <p>
                  {record.reason == 'OF' ? (
                    <>
                      <IntlMessages id='sell.cashlisting.openingfloat' />
                    </>
                  ) : record.reason == 'CI' ? (
                    <>
                      <IntlMessages id='sell.cashlisting.cashin' />
                    </>
                  ) : record.reason == 'CO' ? (
                    <>
                      <IntlMessages id='sell.cashlisting.cashout' />
                    </>
                  ) : record.reason == 'PCI' ? (
                    <>
                      <IntlMessages id='sell.cashlisting.pettycashin' />
                    </>
                  ) : record.reason == 'PCO' ? (
                    <>
                      <IntlMessages id='sell.cashlisting.pettycashout' />
                    </>
                  ) : (
                    <></>
                  )}
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3 style={{ fontWeight: '500', color: '#038fde' }}>{text}</h3>
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.cashlisting.col4' />,
      key: 'transaction',
      dataIndex: 'transaction',
      render: (text, record) => {
        let isOut = false
        if (record.reason == 'CO' || record.reason == 'PCO') {
          isOut = true
        }
        return (
          <p
            className='gx-link'
            style={{
              fontWeight: '700',
              color: isOut ? 'rgb(215, 113, 115)' : '#41af4b'
            }}
          >
            {isOut ? '-' : ''}
            {text ? formatDigits(text, getDecimalPlaces) : '0.00'}
            {getCurrSymbol}
          </p>
        )
      }
    }
  ]

  function onAddClick () {
    setCashRole(1)
    dispatch(loadAddCashModalShow(true))
  }

  function onRemoveClick () {
    setCashRole(2)
    dispatch(loadAddCashModalShow(true))
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setIsLoadingTable(true)
    var body = getPagination
    let cashmanageId = localStorage.getItem('cashManageID')
    body.CashManagementID = cashmanageId
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    body.showSizeChanger = true
    getCashListingService(body)
    setPagination(body)
  }

  return getIsAllowRead ? (
    <>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getReduxCashListingLoading}
        size='large'
      >
        <div className='Content-wrapper CashManagement-pg'>
          {checkIsWeb().exist && (
            <h1 className=''>
              <IntlMessages id='sell.cashlisting.title' />
            </h1>
          )}
          {getOutletName && getRegName ? (
            <>
              {!getReduxIsRegisterOpen ? (
                <>
                  <div
                    style={{
                      marginTop: !getReduxIsRegisterOpen ? '-10px' : '0px'
                    }}
                  >
                    <OpeningFloat
                      isCashManage={true}
                      isCreateDisable={getIsDisableCreate}
                    />
                  </div>
                </>
              ) : (
                <>
                  <Card className='gx-card' title=''>
                    <Row>
                      <Col lg={12} md={12} sm={24} xs={24} className='mt-15'>
                        <h3 className='custom-font-weight-500 mb-0'>
                          <IntlMessages id='sell.cashlisting.subtitle' />{' '}
                          {/* <a href='#' className='orange-color'>
                            <strong>
                              ,<IntlMessages id='sell.cashlisting.subtitle2' />
                            </strong>
                          </a> */}
                        </h3>
                      </Col>

                      <Col
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                        className='Cash-management-button'
                      >
                        <div className='text-right'>
                          {' '}
                          <Button
                            className='dk-btn-cancel'
                            type='primary'
                            onClick={() => onRemoveClick()}
                            size='large'
                            disabled={getIsDisableDelete}
                          >
                            <IntlMessages id='sell.cashlisting.subtitlebtn1' />
                          </Button>
                          <Button
                            className='dk-btn-add font-16'
                            type='primary'
                            onClick={() => onAddClick()}
                            size='large'
                            disabled={getIsDisableCreate}
                          >
                            <IntlMessages id='sell.cashlisting.subtitlebtn2' />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Card>

                  <div className='custom-product-table'>
                    <Card className='noborder table-body'>
                      {isLoading ? (
                        <Skeleton count={7} height={35} />
                      ) : (
                        <Table
                          className='gx-table-responsive'
                          columns={columns}
                          dataSource={getTableData}
                          loading={isLoadingTable}
                          pagination={getPagination}
                          onChange={handleTableChange}
                        />
                      )}
                    </Card>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <Row justify='center'>
                <Col>
                  <h1>Kindly Select Register and Outlet</h1>
                </Col>
              </Row>
            </>
          )}
        </div>
        <CashAdd
          role={getCashRole}
          addAllow={getIsDisableCreate}
          removeAllow={getIsDisableDelete}
        />
      </Spin>
    </>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default CashListing
